var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-option"},_vm._l((_vm.splittedMessage),function(message,index){return _c('span',{key:index,class:message.isPattern ? 'option pattern' : 'option'},[_vm._v(_vm._s(message.text))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }